import React from "react";
import { Activity, FileText, Pill } from "lucide-react";
import { Card } from "@/components/ui/card";
const features = [{
  title: "Quality Workmanship",
  description: "Our skilled craftsmen deliver superior results using premium materials and industry-leading techniques for every project.",
  icon: FileText
}, {
  title: "Experienced Team",
  description: "With decades of combined expertise, our professionals handle complex challenges with precision and dedicated care.",
  icon: Activity
}, {
  title: "Free Estimates",
  description: "Get transparent, detailed pricing for your project with no hidden fees. We provide honest assessments at no cost to you.",
  icon: Pill
}, {
  title: "Licensed & Insured",
  description: "Rest easy knowing your property is protected. We maintain full licensing and comprehensive insurance for your peace of mind.",
  icon: Activity
}];
export default function FeaturesGrid() {
  return <section data-section-id="253732" id="features-grid" className="bg-gradient-to-br from-primary to-secondary py-20 md:py-32">
      <div className="page-container px-4 md:px-8">
        {/* Mascot/Icon Header */}
        <div className="mb-16 flex flex-col items-center justify-center text-center md:mb-24">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/construction_quality_badge.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/construction_quality_badge.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/construction_quality_badge.png-wvc-sizes" alt="Quality Assurance" className="h-40 w-auto object-contain drop-shadow-xl" loading="lazy" />
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-10 lg:gap-12">
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-accent flex flex-col items-center rounded-lg border-none p-8 text-center shadow-medium transition-all duration-300 hover:-translate-y-2 md:p-10">
              <div className="text-primary mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-primary-light">
                <feature.icon className="h-10 w-10" strokeWidth={1.5} />
              </div>
              <h3 className="text-foreground-secondary font-default mb-4 text-2xl font-bold">
                {feature.title}
              </h3>
              <p className="text-muted-foreground font-sans leading-relaxed">
                {feature.description}
              </p>
            </Card>)}
        </div>
      </div>
    </section>;
}